<template>
    <div id="app">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {},
        mounted() {
            this.checkToken()
        },
        methods: {
            checkToken() {
                let token = this.$store.state.token,
                    routerInfo = "Login" // 之前路由来源记录

                if(!token){
                    this.$router && this.$router.replace && this.$router.replace({name: routerInfo})
                } else {
                    this.initUserInfo()
                }
            },

            initUserInfo() {
                // axios.get(Constants.URL.get_user_info).then((response)=>{
                //     this.$store.dispatch('changeLoadingView', false)
                //
                //     const userInfo = response.detail
                //
                //     // 设置全局状态token/userInfo
                //     this.$store.dispatch("setUserInfo", JSON.stringify(userInfo))
                //
                // },(error)=>{
                //     this.$store.dispatch('changeLoadingView', false)
                //     this.$alert(error && error.message || Constants.errorText)
                // })
            }
        }
    }
</script>

<style lang="stylus">
    * {
        padding: 0;
        margin: 0;
        font-family '微软雅黑'
    }

    html {
        width: 100%;
        height: 100%;
    }

    body {
        width: 100%;
        height: 100%;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 100%;
        height: 100%;
    }

    @import "assets/css/variables.styl";
</style>
